<template>
  <div class="memberActive">
    <div class="from_content">
      <div class="step2">
        <h2>课程激活</h2>
        <div>
          <van-field @input="getphoneValue" v-model.trim="tmallCard" type="input" placeholder="请输入防伪码激活" />
          <h3>领取课程说明</h3>
          <h4>1.免费领课仅限购买图书/书课包产品</h4>
          <h4>2.刮开图书封面的扫码领课的图层并输入进行校验</h4>
          <h4>3.每个校验码仅可领取一次课程，是领课的唯一凭证，请谨慎保管及时领课</h4>
          <h4>4.若已购买的图书上未印制防伪码的用户，请前往购买平台的订单中联系客服领取</h4>
          <h4>5.该活动最终解释权归时代云图图书有限责任公司所有</h4>
        </div>
      </div>
    </div>
    <div v-show="hideshow" class="fixedbottom">
      <div class="tmallBtn" :class="{ active: selected !== -1 }" @click="onClickTmall">
        点击激活
      </div>
    </div>
    <Loading ref="load" />
    <CourseSuccess @courseChangeShow="courseChangeShow" :courseShow="courseShow" />
  </div>
</template>

<script>
import Loading from '@/components/loading/loading.vue';
import CourseSuccess from './courseSuccess.vue';
import { reqcheckCode } from '@/api/personal/courseTmall';

export default {
  components: {
    Loading,
    CourseSuccess
  },
  data() {
    return {
      radio: '1',
      tmallCard: '',
      selected: -1,
      onShow: false,
      courseShow: false,
      docmHeight: document.documentElement.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
      hideshow: true, // 显示或者隐藏footer
    };
  },

  computed: {},
  mounted() {
    document.title = '激活中心';
    window.onresize = () => (() => {
      this.showHeight = document.body.clientHeight;
    })();
  },

  methods: {
    changeRadio() {
      this.tmallCard = '';
      this.selected = -1;
    },
    getphoneValue() {
      if (this.tmallCard) {
        this.selected = 0;
      } else {
        this.selected = -1;
      }
    },
    async onClickTmall() {
      if (this.selected === -1) {
        this.$toast('请输入防伪码激活');
        return;
      }
      if (!this.tmallCard) {
        this.$toast('请输入防伪码激活');
      } else {
        this.$refs.load.show = true;
        const res = await reqcheckCode({
          code: this.tmallCard,
          type: this.radio,
        });
        if (res.msg == '请求成功' && res.description != '该防伪码为正版') {
          // 验证成功
          this.courseShow = true;
        } else if (res.msg == '请求成功' && res.description == '该防伪码为正版') {
          this.$toast(res.description);
        } else if (res.code == '19106') {
          // 防伪码已经使用
          this.$toast(res.msg);
        } else if (res.code == '19107') {
          // 您已有该课程
          this.$toast('您已有该课程，请在app中查看');
        } else {
          this.$toast(res.msg);
        }
        this.$refs.load.show = false;
      }
    },
    // 课程
    courseChangeShow() {
      this.courseShow = false;
    },
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.hideshow = false;
      } else {
        this.hideshow = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.memberActive {
  .from_content {
    width: 670px;
    margin: 0 auto;
    padding: 64px 60px 54px 60px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);

    ::v-deep {
      .van-cell {
        padding: 0;

        .van-field__body {
          .van-field__control {
            width: 275px;
            height: 60px;
            padding-left: 16px;
            color: #333;
            font-weight: 400;
            font-size: 14px;
            background: #f8f9fb;
            border-radius: 10px;
          }

          input::-webkit-input-placeholder {
            color: #a5a5a5;
          }
        }
      }

      .van-radio-group--horizontal {
        justify-content: space-around;
        margin-bottom: 20px;

        .van-radio__label {
          font-size: 16px;
        }
      }

    }
  }

  .step2 {
    h2 {
      margin-bottom: 48px;
      color: #333;
      font-weight: 500;
      font-size: 32px;
    }

    h3 {
      margin-top: 40px;
      color: #fc7e36;
      font-weight: 500;
      font-size: 28px;
      line-height: 40px;
      margin-block: 28px;
    }

    h4 {
      color: #999;
      font-weight: 400;
      font-size: 22px;
      font-style: normal;
      line-height: 43px;
    }
  }

  .fixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    padding-top: 32px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;

    .tmallBtn {
      width: 678px;
      height: 80px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
      opacity: 0.5;
    }
  }

  .tmallBtn.active {
    opacity: 1;
  }
}
</style>
